import React, { useState } from 'react';
import { HeartIcon } from 'lucide-react';
interface FavoriteButtonProps {
  initialState?: boolean;
  onChange?: (isFavorite: boolean) => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  itemId?: string;
  itemType?: string;
}
const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  initialState = false,
  onChange,
  className = '',
  size = 'md',
  itemId,
  itemType
}) => {
  const [isFavorite, setIsFavorite] = useState(initialState);
  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the click from affecting parent elements
    const newState = !isFavorite;
    setIsFavorite(newState);
    // In a real app, you would store this in a database or localStorage
    if (itemId && itemType) {
      console.log(`${newState ? 'Added' : 'Removed'} ${itemType} with ID ${itemId} ${newState ? 'to' : 'from'} favorites`);
    }
    if (onChange) onChange(newState);
  };
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10'
  };
  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };
  return <button className={`${sizeClasses[size]} rounded-full flex items-center justify-center transition-colors duration-200 ${isFavorite ? 'bg-gray-200' : 'bg-gray-100 hover:bg-gray-200'} ${className}`} onClick={handleToggle} aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'} data-id="element-410">
      <HeartIcon className={`${iconSizes[size]} ${isFavorite ? 'text-gray-700 fill-gray-700' : 'text-gray-500'}`} data-id="element-411" />
    </button>;
};
export default FavoriteButton;